module.exports = "/assets/b3e6abcaa7871b375f7b85ad45068296.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/AP.png
// module id = 1203
// module chunks = 0